let UTILS = require("../libs/utils.js");
var v7766;
var v7767;
module.exports = {
  id: "depoffa",
  name: "Deposit FFA",
  alias: "depoffa",
  party: true,
  tag: ["Party", "#ffac00", "#ffb600"],
  endStats: ["sid", "name", "score", "kills", "deaths", "deposits", "reward"],
  leaderStats: ["deposits", "kills", "score"],
  objective: true,
  tagLimit: 65,
  objScore: 75,
  killMlt: 0.5,
  noScoreC: true,
  tagHoldLimit: 20,
  deposit: true,
  maxPerCluster: 3,
  gameStart: function (p9269) {
    p9269.activeObjective = -1;
    p9269.randObjective(null, true);
  },
  leaderSort: function (p9270, p9271) {
    if (p9270.deposits === p9271.deposits && p9270.kills && p9271.kills) {
      return p9270.kills - p9271.kills;
    } else {
      return p9271.deposits - p9270.deposits;
    }
  },
  endSort: function (p9272, p9273) {
    if (p9272.deposits === p9273.deposits && p9272.kills && p9273.kills) {
      return p9273.kills - p9272.kills;
    } else {
      return p9273.deposits - p9272.deposits;
    }
  },
  condition: [function (game) {
    for (var vLN01247 = 0; vLN01247 < game.players.list.length; ++vLN01247) {
      if (game.players.list[vLN01247].deposits >= game.mode.tagLimit) {
        return false;
      }
    }
    return true;
  }],
  onKill: function (p9275, p9276, p9277, p9278) {
    var v7768 = p9277.dogTags || 0;
    if (p9278 && p9278 != p9277) {
      v7768 += 1;
    }
    if (v7768) {
      var v7769 = p9277.lastGround && (!p9278 || p9278 == p9277 && v7768 > 1);
      if (p9278 && p9278 != p9277 || v7769) {
        if (p9277.lastGround && !p9277.onGround) {
          v7769 = true;
        }
        var vO218 = {
          x: v7769 ? p9277.lastGround.x : p9277.x,
          y: v7769 ? p9277.lastGround.y : p9277.y,
          z: v7769 ? p9277.lastGround.z : p9277.z
        };
        if (v7768 <= p9275.mode.maxPerCluster) {
          p9275.dropSpawnable(3, p9277, {
            c: v7768
          }, vO218);
        } else {
          for (var v7770 = Math.floor(v7768 / p9275.mode.maxPerCluster), v7771 = v7768 % p9275.mode.maxPerCluster, vLN01248 = 0; vLN01248 < v7770; vLN01248++) {
            p9275.dropSpawnable(3, p9277, {
              c: p9275.mode.maxPerCluster
            }, {
              x: vO218.x + UTILS.randInt(-10, 10),
              y: vO218.y,
              z: vO218.z + UTILS.randInt(-10, 10)
            });
          }
          if (v7771) {
            p9275.dropSpawnable(3, p9277, {
              c: v7771
            }, {
              x: vO218.x + UTILS.randInt(-10, 10),
              y: vO218.y,
              z: vO218.z + UTILS.randInt(-10, 10)
            });
          }
        }
      }
    }
  },
  update: function (game, p9280, p9281) {
    if (game.map.manager.objectives.length && game.waitTimers && game.waitTimers[0].contTime && (game.objectiveTimer -= p9281, game.objectiveTimer <= 0)) {
      game.objectiveTimer = 750;
      for (var vLN01249 = 0; vLN01249 < game.map.manager.objectives.length; ++vLN01249) {
        v7766 = game.map.manager.objectives[vLN01249];
        if (v7766 && v7766.uid == game.activeObjective) {
          for (var vLN01250 = 0; vLN01250 < game.players.list.length; ++vLN01250) {
            v7767 = game.players.list[vLN01250];
            if (v7767.active && v7767.dogTags > 0 && v7767.collides(v7766)) {
              v7767.dogTags--;
              v7767.deposits++;
              game.incMedal("Deposited", v7767);
              game.players.score(v7767, game.mode && game.mode.objScore ? game.mode.objScore : 10);
              v7767.send("am", [49, game.mode && game.mode.objScore ? game.mode.objScore : 10, 0, 1]);
              v7767.send("krt", v7767.dogTags);
              game.challenges.update(game, "dep", 1, null, v7767);
            }
          }
        }
      }
    }
  }
};